import React, { Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import _ from 'lodash';
import { getAlertsByContact, getRemindersByContact, addUpdateNotification, getAncillary} from "store/state/notifications";
import { ToastSuccess } from "components/Global/Toasts/Toasty";
import Header from "./Header";
import AlertTable from "./AlertTable";
import AddEditAlert from "./AddEditAlert";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog"
import SimpleInfoDialog from "components/Global/ConfirmationDialogs/SimpleInfoDialog"
const Spacer = styled.div`
  height: 25px;
`;

const StyledBody = styled.div`
 margin-left: 50px;
`;



class Notifications extends React.Component {
    state = {
        confirmDialogOpen: false,
        isDialogOpen: false,
        selectedItem: {id:null},
        isAlert: null,
        popupOpen:false,
    };

    renderFeatureLockedModel = () => {
        return(
        <SimpleInfoDialog 
                title="Feature Locked"
                message="This feature is only available if you upgrade your account."
                modalOpen={this.state.popupOpen}
                handleClose={this.closePopup}
                handleAccept={this.closePopup}
                secondaryContent={
                    <p>
                    If you would to schedule a demo to view these features, contact <a href ="mailto:sales@loanboss.com">sales@loanboss.com</a>. <br/> <br/>
                    Please contact your LoanBoss Administrator to upgrade or if you believe you are seeing this message in error: <a href="mailto:support@loanboss.com">support@loanboss.com</a>.
                  </p>
                }
                />
          )
      }

    componentDidMount(){
        this.props.getAncillary();
        this.props.getAlertsByContact();
        this.props.getRemindersByContact();
    };

    addAlert = () => {
        this.setState({    
            selectedItem: {id:0},        
            isDialogOpen: true,
            isAlert: true,
            isNew: true,
            
          });
    };

    setReminder = () => {
        this.setState({      
            selectedItem: {id:0},      
            isDialogOpen: true,
            isAlert: false,
            isNew: true,
            
          }); 
    };

    editItem = (item) => {
        this.setState({ 
            selectedItem: item,
            isDialogOpen: true,
            isAlert: item.isAlert,
            isNew: false,
            
        });
    };   

    confirmDeleteItem = (item) => {
        this.setState({ 
            selectedItem: { ...this.state.selectedItem, ...item, isActive: false },
            confirmDialogOpen: true
        });
    };

    deleteItem = () => {
        if(this.state.selectedItem){
            this.setState({                
                isDialogOpen: false,
                confirmDialogOpen: false
            }); 
            this.props.addUpdateNotification(this.state.selectedItem);
        }
    };    

    handleCancel = () => {
        ToastSuccess("Changes Canceled");
        this.setState({
            selectedItem: {id:null}, 
            isDialogOpen: false,
            confirmDialogOpen: false
         });
         this.props.getAlertsByContact();
         this.props.getRemindersByContact();
    };

    handleSave = () => {
        this.setState({ 
            selectedItem: {id:null},
            isDialogOpen: false,
            confirmDialogOpen: false
        });
    };

    isProTier = () => {
        if(this.props.authentication){
            return this.props.authentication.companyLevel==="Professional"
            || this.props.authentication.companyLevel==="Enterprise"
            || this.props.authentication.companyLevel==="Secondary Sponsor"
        }else{
          return false;
        }
      }
    
      openPopup = () =>{
        this.setState({popupOpen: true});
      }
    
      closePopup = () =>{
        this.setState({popupOpen: false});
      }

    
    render() {    
        const {selectedItem, isDialogOpen, confirmDialogOpen} = this.state;
        const { alerts, reminders, ancillary  } = this.props;        
      return (
        <Fragment>
            <AddEditAlert               
              notificationId={selectedItem.id}
              isOpen={isDialogOpen}                          
              handleCancel={this.handleCancel}
              handleSave={this.handleSave}                          
              isAlert={this.state.isAlert}
              isNew={this.state.isNew}
              ancillary={ancillary}/>
            <StyledBody>
                <Grid container>
                    <Grid item xs={12} >
                        <Header parent={this} buttonId="addAlertButton" hasAction title="Alerts" action={this.addAlert} actionTitle={"Add Alert"}/>
                    </Grid>
                    <Grid item xs={12} >
                        <AlertTable editClick={this.editItem} deleteClick={this.confirmDeleteItem} alerts={alerts} isAlert triggerLabel="TRIGGER" />
                    </Grid>
                    
                    <Grid item xs={12} >
                        <Spacer></Spacer>
                    </Grid>
                
                    <Grid item xs={12} >
                        <Header parent={this} buttonId="addReminderButton" hasAction title="Reminders" action={this.setReminder} actionTitle={"Set Reminder"}/>
                    </Grid>
                    <Grid item xs={12} >
                        <AlertTable editClick={this.editItem} deleteClick={this.confirmDeleteItem} alerts={reminders} triggerLabel="DATE OF REMINDER"/>
                    </Grid>
                </Grid>
            </StyledBody>
            <SimpleConfirmDialog 
                title="Confirm Delete"
                message={selectedItem && selectedItem.isAlert ? 
                    "Deleting this alert will delete the alert for your entire company and prevent them from receiving notifications. Are you sure you want to do this?" 
                    : 
                    "Deleting this reminder will delete the reminder for your entire company and prevent them from receiving notifications. Are you sure you want to do this?"}
                noText="Cancel"
                yesText="Yes, Delete"
                modalOpen={confirmDialogOpen}
                handleNo={this.handleCancel}
                handleYes={this.deleteItem} />
           {this.renderFeatureLockedModel()}
        </Fragment>
      );
    }
    }


const mapStateToProps = ({ authentication, notifications }) => ({
    authentication,
    alerts: notifications.alerts ? notifications.alerts.details : [],
    reminders: notifications.reminders ? notifications.reminders.details : [],
    ancillary: notifications.ancillary || [],    
  });
  
  export default connect(
    mapStateToProps,
    {    
        getAlertsByContact, 
        getRemindersByContact,
        addUpdateNotification,
        getAncillary
    }
  )(Notifications);
  








